import { render, staticRenderFns } from "./DepositWithdrawBody.vue?vue&type=template&id=503f4ad6&"
import script from "./DepositWithdrawBody.vue?vue&type=script&lang=ts&"
export * from "./DepositWithdrawBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports